/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update a custom domain for a tenant
 * @export
 * @interface TenantDomainUpdate
 */
export interface TenantDomainUpdate {
    /**
     * The full domain name
     * @type {string}
     * @memberof TenantDomainUpdate
     */
    domain: string;
}

/**
 * Check if a given object implements the TenantDomainUpdate interface.
 */
export function instanceOfTenantDomainUpdate(value: object): value is TenantDomainUpdate {
    if (!('domain' in value) || value['domain'] === undefined) return false;
    return true;
}

export function TenantDomainUpdateFromJSON(json: any): TenantDomainUpdate {
    return TenantDomainUpdateFromJSONTyped(json, false);
}

export function TenantDomainUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantDomainUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'domain': json['domain'],
    };
}

export function TenantDomainUpdateToJSON(json: any): TenantDomainUpdate {
    return TenantDomainUpdateToJSONTyped(json, false);
}

export function TenantDomainUpdateToJSONTyped(value?: TenantDomainUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domain': value['domain'],
    };
}

